export function setUserLoggedIn(username, loggedIn) {
    return { type: 'SET_USER_LOGGED_IN', payload: { username, loggedIn } };
}
